import axios from 'axios';

class BouncedEmailService {

  getCompanyDataFromToken (token) {
    let url = `backend://bounced-email/${token}`;
    return axios.get(url)
      .then((response) => {
        return response;
      });
  }

  updateCompanyEmail (token, email) {
    return axios.post('backend://bounced-email-resend', {
      'data': {
        'attributes': {
          'email': email,
          'token': token
        }
      }
    }).then((response) => {
      return response;
    });
  }

}

export default new BouncedEmailService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/bounced-email/bounced-email-service.js
 **/